import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { ChildConnectionFormProps } from '../types';
import { UniqueJoiningLinkChildConnectionPresentation } from './unique-joining-link-child-connection.presentation';
import { UniqueJoiningLinkChildConnectionVM } from './unique-joining-link-child-connection.viewmodel';

export const UniqueJoiningLinkChildConnectionForm = withViewModel(UniqueJoiningLinkChildConnectionPresentation, (props: ChildConnectionFormProps) => {
    const { accountId, eventId, childConnection, parentConnectionDetails, onChildConnectionUpdated } = props;
    return new UniqueJoiningLinkChildConnectionVM(accountId, eventId, childConnection, parentConnectionDetails, onChildConnectionUpdated);
});